import { render, staticRenderFns } from "./dead.vue?vue&type=template&id=5a109e3f&"
import script from "./dead.vue?vue&type=script&lang=js&"
export * from "./dead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports